// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  ITabProps,
  PillWithContent,
} from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/__internal__/PillWithContentComponent/PillWithContent";
import { DiscoverProductCarousel } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/DiscoverProductCarousel";
import { useQuery_escape_hatch as useStoreTypeQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/logged-out/store-type-carousel/post-hooks";
import { Spacer } from "@faire/web/slate/spacing";
import React, { useState } from "react";

export const DiscoverStoreTypeSection: React.FC<{
  query: string;
  loadTimingRef?: React.RefCallback<HTMLElement>;
  isPageWithFilter?: boolean;
}> = ({ loadTimingRef, query, isPageWithFilter }) => {
  const { data: storeTypeCarousel } = useStoreTypeQuery(
    {
      query,
    },
    {
      enabled: !!query,
    }
  );

  const [currentIndex, setCurrentIndex] = useState(0);

  const storeTypes = storeTypeCarousel?.store_types ?? [];

  const tabs: Array<ITabProps> = storeTypes.map((storeType, index) => ({
    tabName: storeType.store_type_name || `Store ${index + 1}`,
    pathIdentifier: "",
    ctaLink: "",
    ctaLinkText: "",
  }));

  const currentStoreType = storeTypes[currentIndex];
  const currentProducts = currentStoreType?.product_tiles || [];
  const currentBrandMap = currentStoreType?.brand_by_token;

  if (!storeTypes.length || !currentStoreType || !storeTypeCarousel?.title) {
    return null;
  }

  return (
    <PillWithContent
      title={storeTypeCarousel?.title}
      tabs={tabs}
      eventTrackingName="discover_store_section_banner"
      loadTimingRef={loadTimingRef}
      currentIndex={currentIndex}
      setCurrentIndex={setCurrentIndex}
      pauseScroll={() => {}}
      resumeScroll={() => {}}
      className="mx-0! mb-0!"
      childrenClassName="pr-0!"
      isVisible
    >
      <div className="w-inherit md:px-2">
        <Spacer height="3x" />
        <DiscoverProductCarousel
          products={currentProducts}
          brandMap={currentBrandMap}
          requestId={storeTypeCarousel?.request_id}
          isPageWithFilter={isPageWithFilter}
        />
        <Spacer height="3x" />
      </div>
    </PillWithContent>
  );
};
